$(document).ready(function() {
    const
        getInput = function(element) {
            return $(element)
                .parents('.input-number-stepper')
                .find('.input-number-stepper__qty');
        },
        calculateFinalPrice = function(quantity, selector, productId) {
            let priceText = $('span #product-price-'+productId).attr('data-price-amount');
            if(priceText){
                let price = Number(priceText.replace(/[^0-9.-]+/g, ''));

                if(price != 0){
                    selector.text(
                        new Intl.NumberFormat('de-CH', {
                            style: 'currency',
                            currency: 'CHF'
                        }).format( roundDownToMultiple(quantity * price, 5))
                    );
                }
            }


        },
        resetToMinPrice = function(quantity, selector, productId) {
            let priceText = $('.product-info-price .description-list__price .description-list__description').html();
            if(priceText){
                let price = Number(priceText.replace(/[^0-9.-]+/g, ''));

                if(price != 0){
                    selector.text(
                        new Intl.NumberFormat('de-CH', {
                            style: 'currency',
                            currency: 'CHF'
                        }).format( roundDownToMultiple(quantity * price, 5))
                    );
                }
            }


        };

    let roundDownToMultiple = function(number, multiple, precision = 2, rounding = 0.05) {
        let multiply = 1 / rounding;

        return parseFloat((Math.round(number * multiply) / multiply)).toFixed(precision);
    }


    let checkProductOptions = function (formData){
        let productType = formData.find('input:hidden[name=product_type]').val();
        if(productType == 'configurable'){
            let productOption = formData.find('.super-attribute-select').children("option:selected").val();
            if(productOption > 0){
               return true;
            }else{
                formData.find('.super-attribute-select').addClass('mage-error');
                formData.find('.super-attribute-select').focus();
                return false;
            }
        }else{
            return true;
        }
    };


    $('.super-attribute-select').change(function(){
        let productOption = $(this).children("option:selected").val();

        let productId = $(this).data('product-id');
        let formData = $('form[data-product-id="'+productId+'"]');
        let qty = formData.find('input[name=qty]').val();
        let totalElement = formData.find('span #product-price-'+productId+' .price');

        if(productOption > 0){
            calculateFinalPrice(qty, totalElement, productId);

            if($(".description-list__price").find("[data-product-id='"+productId+"'] .unit-price")[0]){
                $(".description-list__price").find("[data-product-id='"+productId+"'] .unit-price").hide();
            }
        }else{
            resetToMinPrice(qty, totalElement, productId);
        }

        if(productOption > 0 && $(this).hasClass('mage-error')){
            $(this).removeClass('mage-error');
        }
    });

    $('.input-number-stepper').on('click', '.input-number-stepper__increment', function(e) {
        e.preventDefault();
        e.stopPropagation();

        let productId = $(this).data('product-id');
        let formData = $('form[data-product-id="'+productId+'"]');
        let totalElement = formData.find('span #product-price-'+productId+' .price');

        const $input = getInput(this);

        if(checkProductOptions(formData)){
            $input[0].stepUp();
            calculateFinalPrice($input.val(), totalElement, productId);
        }


    });

    $('.input-number-stepper').on('click', '.input-number-stepper__decrement', function(e) {
        e.preventDefault();
        e.stopPropagation();

        let productId = $(this).data('product-id');
        let formData = $('form[data-product-id="'+productId+'"]');
        let totalElement = formData.find('span #product-price-'+productId+' .price');

        const $input = getInput(this);

        if(checkProductOptions(formData)){
            $input[0].stepDown();
            calculateFinalPrice($input.val(), totalElement, productId);
        }
    });

    if ($('.catalog-product-view .product-info-main .product-add-form').length) {
        calculateFinalPrice($('.input-number-stepper__qty').val(), $('.catalog-product-view .product-info-main .product-add-form .container-price .price-final_price .price'));
    }

    window.numberStepper = function() {

        let $specialPrice = $('.description-list__price .description-list__description .special-price');

        let $normalPrice = $('.description-list__price .description-list__description');

        let $price = $normalPrice.last().text();

        if ($specialPrice.length) {
            $price = $specialPrice.text();
        }

        let priceText = $price,
            price = Number(priceText.replace(/[^0-9.-]+/g, '')),
            getInput = function(element) {
                return $(element)
                    .parent('.input-number-stepper')
                    .find('.input-number-stepper__qty');
            },
            calculateFinalPrice = function(quantity, selector, productId) {
                if(productId){
                    priceText = $('span #product-price-'+productId).attr('data-price-amount');
                    price = Number(priceText.replace(/[^0-9.-]+/g, ''));
                }

                selector.text(
                    new Intl.NumberFormat('de-CH', {
                        style: 'currency',
                        currency: 'CHF'
                    }).format( roundDownToMultiple(quantity * price, 5))
                );
            };

        $('.input-number-stepper').on('click', '.input-number-stepper__increment', function(e) {
            e.preventDefault();
            e.stopPropagation();

            let productId = $(this).data('product-id');
            let formData = $('form[data-product-id="'+productId+'"]');
            let totalElement = formData.find('span #product-price-'+productId+' .price');

            const input = getInput(this);
            if(checkProductOptions(formData)){
                input[0].stepUp();
                calculateFinalPrice(input.val(), totalElement, productId);
            }
        });

        $('.input-number-stepper').on('click', '.input-number-stepper__decrement', function(e) {
            e.preventDefault();
            e.stopPropagation();

            let productId = $(this).data('product-id');
            let formData = $('form[data-product-id="'+productId+'"]');
            let totalElement = formData.find('span #product-price-'+productId+' .price');

            const input = getInput(this);
            if(checkProductOptions(formData)){
                input[0].stepDown();
                calculateFinalPrice(input.val(), totalElement, productId);
            }
        });
    };

    var _stepperInterval = setTimeout(function() {
        if ($('.input-number-stepper').length) {
            var $val = $('.input-number-stepper .input-number-stepper__qty').val();
        var productId =  $('.input-number-stepper .input-number-stepper__qty').data('product-id');
        var formData = $('form[data-product-id="'+productId+'"]');
        var totalElement = formData.find('span #product-price-'+productId+' .price');
        calculateFinalPrice($val, totalElement, productId);
        }
    }, 150);
});
